module.exports = __webpack_public_path__ + "img/fluidMechanics_sign.bc56c2c9.png";